export enum PlanningRoutes {
  accommodations = '/planning/accommodations',
  hotelblock = '/planning/hotelblock',
  form = '/planning/hotelblock/form',
  hotelSelection = '/planning/hotelblock/hotelselection',
  honeymoon = '/honeymoon',
}
